import { VolcanoIcon } from './VolcanoIcon';

/**
 * author: Google
 * id F319008C-CAC3-4D75-8DED-8164D252A015
 * name volcano
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/volcano.svg
 * tags
 * - Nature 
 */
export const EruptionIcon = VolcanoIcon;
export default EruptionIcon